import * as React from 'react';

function SvgCreditcardStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.916 7.656H7.09a2.72 2.72 0 00-2.72 2.72V20.63a2.72 2.72 0 002.72 2.72h15.825a2.72 2.72 0 002.72-2.72V10.376a2.72 2.72 0 00-2.72-2.72zm1.42 5.791v-1.429H5.67v1.43h18.665zm-18.665 1.3h18.665v5.884a1.42 1.42 0 01-1.42 1.42H7.09a1.42 1.42 0 01-1.42-1.42v-5.884zm0-4.029h18.665v-.342a1.42 1.42 0 00-1.42-1.42H7.09a1.42 1.42 0 00-1.42 1.42v.342zm3.627 6.236a.65.65 0 110 1.3H7.215a.65.65 0 010-1.3h2.083zm4.185 2.851a.65.65 0 00-.65-.65H7.215a.65.65 0 000 1.3h5.618a.65.65 0 00.65-.65z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgCreditcardStroke;
